import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.07 14.43 12 20.5l-6.07-6.07M12 3.5v16.83",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }